import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { $window, rgb2arr } from '@antv/l7-utils';
import { inject, injectable } from 'inversify';
import 'reflect-metadata';
import { TYPES } from "../../types";
import Clock from "../../utils/clock";
import { throttle } from 'lodash';
var LayerService = (_dec = injectable(), _dec2 = inject(TYPES.IRendererService), _dec3 = inject(TYPES.IMapService), _dec(_class = (_class2 = /*#__PURE__*/function () {
  function LayerService() {
    var _this = this;

    _classCallCheck(this, LayerService);

    _defineProperty(this, "pickedLayerId", -1);

    _defineProperty(this, "clock", new Clock());

    _defineProperty(this, "alreadyInRendering", false);

    _defineProperty(this, "layers", []);

    _defineProperty(this, "layerList", []);

    _defineProperty(this, "layerRenderID", void 0);

    _defineProperty(this, "sceneInited", false);

    _defineProperty(this, "animateInstanceCount", 0);

    _defineProperty(this, "shaderPicking", true);

    _defineProperty(this, "enableRender", true);

    _initializerDefineProperty(this, "renderService", _descriptor, this);

    _initializerDefineProperty(this, "mapService", _descriptor2, this);

    _defineProperty(this, "reRender", throttle(function () {
      _this.updateLayerRenderList();

      _this.renderLayers();
    }, 32));

    _defineProperty(this, "throttleRenderLayers", throttle(function () {
      _this.renderLayers();
    }, 16));
  }

  _createClass(LayerService, [{
    key: "add",
    value: function add(layer) {
      if (this.sceneInited) {
        layer.init();
      }

      this.layers.push(layer);
      this.updateLayerRenderList();
    }
  }, {
    key: "addMask",
    value: function addMask(mask) {
      if (this.sceneInited) {
        mask.init();
      }
    }
  }, {
    key: "initLayers",
    value: function initLayers() {
      this.sceneInited = true;
      this.layers.forEach(function (layer) {
        if (!layer.inited) {
          layer.init();
        }
      });
      this.updateLayerRenderList();
    }
  }, {
    key: "getSceneInited",
    value: function getSceneInited() {
      return this.sceneInited;
    }
  }, {
    key: "getRenderList",
    value: function getRenderList() {
      return this.layerList;
    }
  }, {
    key: "getLayers",
    value: function getLayers() {
      return this.layers;
    }
  }, {
    key: "getLayer",
    value: function getLayer(id) {
      return this.layers.find(function (layer) {
        return layer.id === id;
      });
    }
  }, {
    key: "getLayerByName",
    value: function getLayerByName(name) {
      return this.layers.find(function (layer) {
        return layer.name === name;
      });
    }
  }, {
    key: "cleanRemove",
    value: function cleanRemove(layer) {
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var layerIndex = this.layers.indexOf(layer);

      if (layerIndex > -1) {
        this.layers.splice(layerIndex, 1);
      }

      if (refresh) {
        this.throttleRenderLayers();
      }
    }
  }, {
    key: "remove",
    value: function remove(layer, parentLayer) {
      // Tip: layer.layerChildren 当 layer 存在子图层的情况
      if (parentLayer) {
        var layerIndex = parentLayer.layerChildren.indexOf(layer);

        if (layerIndex > -1) {
          parentLayer.layerChildren.splice(layerIndex, 1);
        }
      } else {
        var _layerIndex = this.layers.indexOf(layer);

        if (_layerIndex > -1) {
          this.layers.splice(_layerIndex, 1);
        }
      }

      this.updateLayerRenderList();
      layer.destroy();
    }
  }, {
    key: "removeAllLayers",
    value: function removeAllLayers() {
      this.destroy();
    }
  }, {
    key: "setEnableRender",
    value: function setEnableRender(flag) {
      this.enableRender = flag;
    }
  }, {
    key: "renderLayers",
    value: function () {
      var _renderLayers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, layer;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.alreadyInRendering || !this.enableRender)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.alreadyInRendering = true;
                this.clear();
                _iterator = _createForOfIteratorHelper(this.layerList);
                _context.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context.next = 21;
                  break;
                }

                layer = _step.value;
                layer.hooks.beforeRenderData.call();
                layer.hooks.beforeRender.call();

                if (layer.masks.length > 0) {
                  // 清除上一次的模版缓存
                  this.renderService.clear({
                    stencil: 0,
                    depth: 1,
                    framebuffer: null
                  });
                  layer.masks.map(function (m) {
                    m.hooks.beforeRenderData.call();
                    m.hooks.beforeRender.call();
                    m.render();
                    m.hooks.afterRender.call();
                  });
                }

                if (!layer.getLayerConfig().enableMultiPassRenderer) {
                  _context.next = 17;
                  break;
                }

                _context.next = 15;
                return layer.renderMultiPass();

              case 15:
                _context.next = 18;
                break;

              case 17:
                layer.render();

              case 18:
                layer.hooks.afterRender.call();

              case 19:
                _context.next = 7;
                break;

              case 21:
                _context.next = 26;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](5);

                _iterator.e(_context.t0);

              case 26:
                _context.prev = 26;

                _iterator.f();

                return _context.finish(26);

              case 29:
                this.alreadyInRendering = false;

              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 23, 26, 29]]);
      }));

      function renderLayers() {
        return _renderLayers.apply(this, arguments);
      }

      return renderLayers;
    }()
  }, {
    key: "updateLayerRenderList",
    value: function updateLayerRenderList() {
      var _this2 = this;

      // Tip: 每次更新都是从 layers 重新构建
      this.layerList = [];
      this.layers.filter(function (layer) {
        return layer.inited;
      }).filter(function (layer) {
        return layer.isVisible();
      }).sort(function (pre, next) {
        // 根据 zIndex 对渲染顺序进行排序
        return pre.zIndex - next.zIndex;
      }).forEach(function (layer) {
        _this2.layerList.push(layer);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.layers.forEach(function (layer) {
        layer.destroy();
      });
      this.layers = [];
      this.layerList = [];
      this.renderLayers();
    }
  }, {
    key: "startAnimate",
    value: function startAnimate() {
      if (this.animateInstanceCount++ === 0) {
        this.clock.start();
        this.runRender();
      }
    }
  }, {
    key: "stopAnimate",
    value: function stopAnimate() {
      if (--this.animateInstanceCount === 0) {
        this.stopRender();
        this.clock.stop();
      }
    }
  }, {
    key: "getOESTextureFloat",
    value: function getOESTextureFloat() {
      return this.renderService.extensionObject.OES_texture_float;
    } // 控制着色器颜色拾取计算

  }, {
    key: "enableShaderPick",
    value: function enableShaderPick() {
      this.shaderPicking = true;
    }
  }, {
    key: "disableShaderPick",
    value: function disableShaderPick() {
      this.shaderPicking = false;
    }
  }, {
    key: "getShaderPickStat",
    value: function getShaderPickStat() {
      return this.shaderPicking;
    }
  }, {
    key: "clear",
    value: function clear() {
      var color = rgb2arr(this.mapService.bgColor);
      this.renderService.clear({
        color: color,
        depth: 1,
        stencil: 0,
        framebuffer: null
      });
    }
  }, {
    key: "runRender",
    value: function runRender() {
      this.renderLayers();
      this.layerRenderID = $window.requestAnimationFrame(this.runRender.bind(this));
    }
  }, {
    key: "stopRender",
    value: function stopRender() {
      $window.cancelAnimationFrame(this.layerRenderID);
    }
  }]);

  return LayerService;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "renderService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "mapService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
export { LayerService as default };